export enum NotificationType {
    Error,
    Success,
    Notice,
    ErrorPlaceholder
}

export const statusClassMap: Record<NotificationType, string> = {
    [NotificationType.Error]: 'error',
    [NotificationType.ErrorPlaceholder]: ['error', 'placeholder'],
    [NotificationType.Success]: 'success',
    [NotificationType.Notice]: 'notice',
};